export const isLoadingSelector = (state) => {
  const stateKeys = Object.keys(state);

  return stateKeys.reduce((isLoading, stateKey) => {
    return isLoading || state[stateKey].isLoading;
  }, false);
};
